import { Row } from "react-table";

type Params<T> = {
  /** 선택 불가(disabled) 행 판별 — 이미 등록된 항목 등 */
  isRowDisabled: (item: T) => boolean;
  /** 행이 현재 선택되어 있는지 판별 */
  isRowSelected: (item: T) => boolean;
  /** 전체 토글 시 호출. enabledItems = 현재 페이지의 선택 가능 행들만 */
  onToggleAll: (enabledItems: T[], checked: boolean) => void;
};

/**
 * 테이블 헤더 "전체선택" 체크박스 로직 (상태 비소유, 로직 전용).
 * - 선택 불가 행은 제외하고 계산/토글
 * - 상태 형태(객체 배열 / id 배열)는 각 모달이 소유하고 콜백으로 주입
 */
export function useSelectAllColumn<T extends object>({ isRowDisabled, isRowSelected, onToggleAll }: Params<T>) {
  /** 현재 페이지 rows 기준 헤더 체크 상태 (선택 불가 행 제외 후 전부 선택됐는가) */
  const getHeaderChecked = (rows: Row<T>[]) => {
    const enabled = rows.filter((r) => !isRowDisabled(r.original));
    return enabled.length > 0 && enabled.every((r) => isRowSelected(r.original));
  };

  /** 현재 페이지의 선택 가능 행 전체를 토글 */
  const handleToggleAll = (rows: Row<T>[], checked: boolean) => {
    const enabled = rows.filter((r) => !isRowDisabled(r.original)).map((r) => r.original);
    onToggleAll(enabled, checked);
  };

  return { getHeaderChecked, handleToggleAll };
}
